import { render, staticRenderFns } from "./buttonText.vue?vue&type=template&id=d32a2220&scoped=true&"
import script from "./buttonText.vue?vue&type=script&lang=js&"
export * from "./buttonText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32a2220",
  null
  
)

export default component.exports